import { useTranslation } from "react-i18next";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../../../../Project/ProjectManagement/AddProject.style";
import { Stack } from "@fluentui/react";
import Layout from "../../../../../styles/Layout.styles";
import { FieldsInput } from "../../../../../components";

const ShortCode = (props) => {
  const { shortCode } = props;
  const { t } = useTranslation();
  const style = Style();
  const layout = Layout();
  return (
    <>
      <Stack className={mergeClasses(layout.w_100, layout.mr_1)}>
        <Stack className={mergeClasses(layout.textbox)}>
          <FieldsInput
            label={t("project.short_code")}
            validationMessage={props.errors?.shortCode?.message}
            id="shortCode"
            placeholder={t("project.enter_short_code")}
            name="shortCode"
            inputDefaultValue={shortCode}
            inputClassName={mergeClasses(style.textboxInput)}
            validation={props.register("shortCode", {
              required: `${t("validation_message.short_code_is_required")}`,
            })}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default ShortCode;
